export const instagramUrl = 'https://www.instagram.com/bright_digital_hubonline'
export const checkoutUrl = 'https://complete-injury-rehabilitation-bundle.impultienda.ar/checkout'
export const offerAnchor = '#offer'
export const contactEmail = 'compradigitalyaa@gmail.com'

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/fw4Me45YHCxjyrPdeDLonU/Paquete_Completo_de_Rehabilitacion_de_Lesiones.png'

export const photos = {
  coachGuiding:
    'https://cdn.magicpatterns.com/patterns/generated-images/053eb7cc-78c9-4a0d-85d7-afeb531ef7ea.jpg',
  bandRotation:
    'https://cdn.magicpatterns.com/patterns/generated-images/81572498-7320-4ec1-92d4-cdda6ca80543.jpg',
}

export const heroAreas = ['Shoulder', 'Knee', 'Ankle', 'Elbow, Wrist & Hand', 'Spine & Hip']

export const stats = [
  ['5', 'Complete Volumes'],
  ['5', 'Practical Bonuses'],
  ['3', 'Training Levels'],
  ['Home + Gym', 'Exercise Options'],
  ['PDF', 'Digital Access'],
] as const

export const problems = [
  'Which exercise fits this stage?',
  'How many sets and reps should be used?',
  'How long should the rest be?',
  'Which variation should come next?',
  'How can the exercise be adapted to different levels?',
  'How should mobility, strength and stability work fit together?',
]

export const howSteps = [
  { number: '01', title: 'Identify the body area', text: 'Shoulder, knee, ankle, elbow, wrist, hand, spine or hip.' },
  { number: '02', title: 'Choose the level', text: 'Beginner, intermediate or advanced.' },
  { number: '03', title: 'Follow the exercise', text: 'Execution, sets, reps or time and rest are already organized.' },
  {
    number: '04',
    title: 'Progress step by step',
    text: 'Use the regression or progression according to the current level and movement control.',
  },
] as const

export const adjustments = ['Range', 'Support', 'Resistance', 'Exercise Variation']

export type Volume = {
  number: string
  name: string
  focus: string
  text: string
}

export const volumes: Volume[] = [
  {
    number: '01',
    name: 'Shoulder Rehabilitation & Strengthening',
    focus: 'Mobility • Activation • Strength • Stability',
    text: 'Shoulder mobility, rotator cuff work, scapular control and progressive strengthening.',
  },
  {
    number: '02',
    name: 'Knee Rehabilitation & Strengthening',
    focus: 'Mobility • Strength • Balance • Control',
    text: 'Quadriceps, hamstrings, glutes, squat patterns, step progressions and unilateral control.',
  },
  {
    number: '03',
    name: 'Ankle Rehabilitation & Strengthening',
    focus: 'Mobility • Strength • Balance • Proprioception',
    text: 'Ankle mobility, calf strength, foot control and progressive single-leg work.',
  },
  {
    number: '04',
    name: 'Elbow, Wrist & Hand Rehabilitation & Strengthening',
    focus: 'Strength • Grip • Control • Progressive Loading',
    text: 'Forearm, wrist, hand and grip exercises organized from basic control to progressive strength.',
  },
  {
    number: '05',
    name: 'Spine & Hip Rehabilitation & Strengthening',
    focus: 'Mobility • Core • Hip Strength • Functional Movement',
    text: 'Trunk control, core stability, hip mobility, glute strength, hinge patterns and unilateral work.',
  },
]

export const levelPath = ['Beginner', 'Intermediate', 'Advanced']

export const sampleMeta = [
  ['Level', 'Beginner / Intermediate'],
  ['Primary goal', 'Rotator Cuff Strength & Control'],
  ['Equipment', 'Resistance Band'],
] as const

export const sampleRows = [
  ['Exercise', 'Band External Rotation'],
  ['Sets / Reps', '3 × 10–12'],
  ['Rest', '45–60 sec'],
  ['Coaching cue', 'Keep the elbow controlled and close to the body.'],
  ['Regression', 'Use lighter resistance.'],
  ['Progression', 'Increase resistance gradually.'],
] as const

export const exerciseStructure = [
  'Starting Position',
  'Execution',
  'Sets',
  'Reps / Time',
  'Rest',
  'Regression',
  'Progression',
]
